$(document).ready(function () {
    function loadScript(src, callback) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () {
            if (callback)
                callback();
        };
        document.head.appendChild(script);
    }
    function initSnowplow() {
        const appName = 'video-search-' + appConfig.clientId;
        const config = {
            env: appConfig.clientId,
            appName: appName,
            activityTracking: {
                minimumVisitLength: 10,
                heartbeatDelay: 10,
            },
        };
        const snowplowVendor = new Snowplow({ config });
        snowplowVendor.enableAutomaticLinkTracking();
        snowplowVendor.refreshLinkTracking();
        snowplowVendor.enableFormTracking();
        snowplowVendor.enableErrorTracking({
            filter: (error) => {
                if (error.type === 'error' && error.target && error.target.tagName === 'IMG') {
                    return false;
                }
                return true;
            },
        });
        window.snowplowVendor = snowplowVendor;
        if (window.spUID) {
            // Login happened before sp library is ready
            window.snowplowVendor.setUserId(window.spUID);
        }
    }
    loadScript('../snowplow/index.js', initSnowplow);
    angular.bootstrap(angular.element('body')[0], ['archie']);
    console.log('Git branch:', GIT_BRANCH);
    console.log('Git revision:', GIT_REVISION);
});
